import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { changePasswordValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import PasswordField from "../Reusable/PasswordInput";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const ChangePassword = (props: any) => {
  const { profile } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm<any>({
    resolver: yupResolver(changePasswordValidationForm),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`profile`],
    navigateURL: "",
  });
  const handleChangePassword = async (values: any, setError: any) => {
    const url = `${APIS.CHANGE_PASSWORD}`;
    let formData = {
      ...values,
      email: profile?.email,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        props?.setOpenChangePasswordPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <PasswordField
        register={register("password")}
        label={"New Password"}
        errors={errors?.password}
      />
      <PasswordField
        register={register("confirm_password")}
        label={"Confirm New Password"}
        errors={errors?.confirm_password}
      />
      <Button
        type={"button"}
        isLoading={isPostLoading}
        label={"Change Password"}
        onClick={handleSubmit((data: any) =>
          handleChangePassword(data, setError)
        )}
      />
    </>
  );
};

export default ChangePassword;
